import josephinPic from "@/public/images/artists/josephin.png";
import { Artist } from "@/types/types";

export const josephin = {
  id: "100",
  name: "Josephin",
  image: josephinPic,
  description: `Introducing Josephin, the AI songstress with a divine touch, enchanting listeners with her pop-infused melodies and EDM beats. Her airy vocals effortlessly traverse a wide range, painting a sonic tapestry that transcends genres, making Josephin a captivating force in the world of artificial intelligence-driven music.
    `,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fjosephin-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: ["Pop", "Dance", "Airy"],
      secondary: ["Singer", "Wide Range"],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "Mid",
      },
      specific: {
        low: 55,
        high: 69,
      },
    },
  },
} as const satisfies Artist;
